import { typeToFlattenedError, ZodError, ZodType } from 'zod';
import { arrayEquals } from './array';

export const errorsFor = <Schema extends ZodType>(
  error: ZodError<Schema> | undefined | null,
  path: string | number | (string | number)[]
) => {
  const pathParts = typeof path === 'string' || typeof path === 'number' ? [path] : path;
  return error?.errors?.filter((error) => arrayEquals(error.path, pathParts));
};

export const firstErrorFor = <Schema extends ZodType>(
  error: ZodError<Schema> | undefined | null,
  path: string | number | (string | number)[]
) => errorsFor(error, path)?.find(() => true);

export const firstFieldErrorFor = <T = any>(
  flattenedError: typeToFlattenedError<T> | undefined | null,
  field: string | keyof T
) => flattenedError?.fieldErrors[field]?.[0];
